import { HTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface BrutalCardProps extends HTMLAttributes<HTMLDivElement> {}

const BrutalCard = forwardRef<HTMLDivElement, BrutalCardProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "bg-card border-[3px] border-dark shadow-[8px_8px_0px_0px] shadow-dark p-8 transition-all hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[6px_6px_0px_0px] hover:shadow-dark",
          className
        )}
        {...props}
      />
    );
  }
);

BrutalCard.displayName = "BrutalCard";

export { BrutalCard };
